import React, { useEffect, useState } from "react";
import { MapPin, X } from "lucide-react";
import { api } from "../lib/api";
import { LOC_ON_KEY } from "../hooks/useOwnerLocation";

export const LocationToggle = () => {
  const [open, setOpen] = useState(false);
  const [st, setSt] = useState(null);

  const load = () => api.get("/nexus/location").then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async () => {
    const r = (await api.post("/nexus/location/settings", { enabled: !st?.enabled })).data;
    localStorage.setItem(LOC_ON_KEY, r.enabled ? "1" : "0");
    window.dispatchEvent(new Event("nexus-loc-toggle"));
    setSt(r);
  };

  const on = st?.enabled;
  const last = st?.latest;
  return (
    <div className="relative">
      <button onClick={() => { setOpen((v) => !v); load(); }} data-testid="nexus-location-btn" title="Location settings"
        className={`px-3 py-1.5 rounded-full nx-mono text-[10px] tracking-widest font-bold flex items-center gap-1.5 border transition-colors ${on ? "text-emerald-300 border-emerald-400/40" : "text-cyan-200/50 border-cyan-200/25"}`}>
        <MapPin className="w-3.5 h-3.5" /> {on ? "LOC" : "LOC OFF"}
      </button>
      {open && (
        <div className="absolute right-0 top-10 z-40 w-72 rounded-xl border border-[#00F0FF33] bg-[#061018] p-4 shadow-2xl" data-testid="nexus-location-panel">
          <div className="flex items-center justify-between mb-3">
            <p className="nx-mono text-[10px] tracking-widest text-cyan-200/70">LOCATION SETTINGS</p>
            <button onClick={() => setOpen(false)} data-testid="nexus-location-close" className="text-cyan-200/50"><X className="w-4 h-4" /></button>
          </div>
          <button onClick={toggle} data-testid="nexus-location-toggle"
            className={`w-full py-2 rounded-lg nx-mono text-xs font-bold tracking-widest ${on ? "bg-emerald-400 text-[#030712]" : "bg-cyan-200/10 text-cyan-100"}`}>
            {on ? "TRACKING ON — TAP TO TURN OFF" : "TRACKING OFF — TAP TO TURN ON"}
          </button>
          <p className="mt-3 text-[11px] text-cyan-100/70" data-testid="nexus-location-address">
            {last ? (last.address || `${last.lat.toFixed(4)}, ${last.lng.toFixed(4)}`) : "No fix yet — open Nexus on your phone and allow location."}
          </p>
          {last && <p className="text-[10px] nx-mono text-cyan-200/40 mt-1" data-testid="nexus-location-time">as of {new Date(last.ts).toLocaleTimeString()} · {st.points_24h} points / 24h</p>}
          <p className="text-[10px] text-cyan-200/40 mt-2">Shared only while Nexus is open on your phone. Kept 24h, visible only to you.</p>
        </div>
      )}
    </div>
  );
};
